import loadable from '@loadable/component';

import './imprint.css';

export default loadable(() => {
  return import('./imprint.jsx');
});
